import {ID, Response} from '../../../../_metronic/helpers'

export type ClassifiedPost = {
  id?: ID
  title?: string
  description?: string
  category?:
    | string
    | {
        id?: string
        name?: string
        icon?: string
      }
  subCategory?:
    | string
    | {
        id?: string
        name?: string
      }
  price?: number
  currency?: string
  location?: {
    address?: string
    city?: string
    state?: string
    country?: string
    zipCode?: string
    coordinates?: {
      lat?: number
      lng?: number
    }
  }
  contactInfo?: {
    name?: string
    email?: string
    phone?: string
    showPhone?: boolean
    showEmail?: boolean
  }
  mainImage?: string
  images?: string[]
  videos?: string[]
  features?: string[]
  condition?: 'New' | 'Like New' | 'Good' | 'Fair' | 'Poor'
  status?: 'Active' | 'Inactive' | 'Sold' | 'Expired'
  approvalStatus?: 'Pending' | 'Approved' | 'Rejected'
  isPromoted?: boolean
  isFeatured?: boolean
  views?: number
  likes?: number
  author?: {
    id?: string
    first_name?: string
    last_name?: string
    email?: string
  }
  tags?: string[]
  expiryDate?: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
}

export type ClassifiedCategory = {
  id?: ID
  name?: string
  icon?: string
  description?: string
  status?: 'Active' | 'Inactive'
  subCategories?: string[]
  posts?: string[]
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
}

export type ClassifiedSubCategory = {
  id?: ID
  name?: string
  category?: string | ClassifiedCategory
  description?: string
  status?: 'Active' | 'Inactive'
  posts?: string[]
  createdAt?: string
  updatedAt?: string
  deletedAt?: string
}

export type ClassifiedStatistics = {
  totalPosts?: number
  activePosts?: number
  pendingPosts?: number
  featuredPosts?: number
  promotedPosts?: number
}

export type ClassifiedPostQueryResponse = Response<Array<ClassifiedPost>>

export type ClassifiedCategoryQueryResponse = {
  data?: Array<ClassifiedCategory>
  ok?: boolean
  pagination?: {
    page?: number
    last_page?: number
    totalDocs?: number
    items_per_page?: number
    from?: number
    to?: number
    links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
  }
}

export type ClassifiedSubCategoryQueryResponse = {
  data?: Array<ClassifiedSubCategory>
  ok?: boolean
  pagination?: {
    page?: number
    last_page?: number
    totalDocs?: number
    items_per_page?: number
    from?: number
    to?: number
    links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
  }
}

export const initialPost: ClassifiedPost = {
  title: '',
  description: '',
  category: undefined,
  subCategory: undefined,
  price: 0,
  currency: 'USD',
  location: {
    address: '',
    city: '',
    state: '',
    country: 'US',
    zipCode: '',
  },
  contactInfo: {
    name: '',
    email: '',
    phone: '',
    showPhone: true,
    showEmail: true,
  },
  mainImage: '',
  images: [],
  videos: [],
  features: [],
  condition: 'Good',
  status: 'Active',
  approvalStatus: 'Pending',
  isPromoted: false,
  isFeatured: false,
  tags: [],
}

export const initialCategory: ClassifiedCategory = {
  name: '',
  icon: '',
  description: '',
  status: 'Active',
}

export const initialSubCategory: ClassifiedSubCategory = {
  name: '',
  category: '',
  description: '',
  status: 'Active',
}
